(function () {
  'use strict';

  var HANDLES = {
    'sleeveless-regular-fit-tshirt-men': 1,
    'womens-biker-shorts': 1,
    'womens-everyday-joggers': 1,
    'womens-power-crop': 1,
    'womens-tank-top': 1,
    'terra-sports-bra': 1,
    'the-off-hours-wide-leg': 1,
    'men-raglan-tshirt': 1,
    'align-sports-bra': 1,
    'mens-everyday-joggers': 1,
    'mens-essential-shorts': 1,
    'the-first-set': 1,
  };

  var cfg = window.WEARTH_SEEN_REAL || {};

  function productHandle() {
    if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
      return ShopifyAnalytics.meta.product.handle || '';
    }
    var m = document.querySelector('link[rel="canonical"]');
    if (m && m.href) {
      var parts = m.href.split('/products/');
      if (parts[1]) return parts[1].split('?')[0].split('#')[0];
    }
    var body = document.body && document.body.className ? document.body.className : '';
    var tokens = body.split(/\s+/);
    for (var i = 0; i < tokens.length; i++) {
      if (HANDLES[tokens[i]]) return tokens[i];
    }
    return '';
  }

  function insertAnchor() {
    return (
      document.querySelector('.wearth-pdp-block--buy .product-form__quantity') ||
      document.querySelector('.product-form__quantity')
    );
  }

  function loadCss(href) {
    if (!href || document.querySelector('link[data-seen-real-css]')) return;
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.setAttribute('data-seen-real-css', '1');
    document.head.appendChild(link);
  }

  function loadScript(src, cb) {
    if (!src) {
      if (cb) cb();
      return;
    }
    var existing = document.querySelector('script[data-seen-real-js]');
    if (existing) {
      if (cb) cb();
      return;
    }
    var s = document.createElement('script');
    s.src = src;
    s.defer = true;
    s.setAttribute('data-seen-real-js', '1');
    s.onload = function () {
      if (cb) cb();
    };
    document.body.appendChild(s);
  }

  function buildSection(handle) {
    var section = document.createElement('section');
    section.className = 'seen-real-bodies';
    section.setAttribute('data-seen-real-bodies', '');
    section.setAttribute('data-product-handle', handle);
    section.setAttribute('data-map-url', cfg.map || '');
    section.setAttribute('data-interval', '4000');
    section.setAttribute('aria-label', 'Seen on real bodies');

    section.innerHTML =
      '<div class="page-width seen-real-bodies__wrap">' +
      '<header class="seen-real-bodies__header">' +
      '<h2 class="seen-real-bodies__title">Seen on real bodies</h2>' +
      '<p class="seen-real-bodies__sub">Not models. Real customers, real fit.</p>' +
      '</header>' +
      '<div class="seen-real-bodies__carousel" data-carousel>' +
      '<button type="button" class="seen-real-bodies__arrow seen-real-bodies__arrow--prev" data-prev aria-label="Previous slide">' +
      '<span aria-hidden="true">&#8592;</span></button>' +
      '<div class="seen-real-bodies__viewport" data-viewport>' +
      '<div class="seen-real-bodies__track" data-track></div>' +
      '</div>' +
      '<button type="button" class="seen-real-bodies__arrow seen-real-bodies__arrow--next" data-next aria-label="Next slide">' +
      '<span aria-hidden="true">&#8594;</span></button>' +
      '</div>' +
      '<div class="seen-real-bodies__dots" data-dots role="tablist" aria-label="Slide navigation"></div>' +
      '</div>';

    return section;
  }

  function hydrate() {
    var handle = productHandle();
    if (!HANDLES[handle]) return;
    if (document.querySelector('[data-seen-real-bodies]')) return;

    var anchor = insertAnchor();
    if (!anchor || !cfg.map) return;

    loadCss(cfg.css);
    var el = buildSection(handle);
    el.classList.add('seen-real-bodies--pdp-inline');
    anchor.parentNode.insertBefore(el, anchor.nextSibling);

    loadScript(cfg.js, function () {
      if (typeof window.initSeenRealBodies === 'function') {
        window.initSeenRealBodies();
      }
      document.dispatchEvent(new Event('seen-real-bodies-hydrated'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrate);
  } else {
    hydrate();
  }
})();
